if (!customElements.get('yotpo-points')) {

    class YotpoProductPoints extends HTMLElement {
        
      constructor() {
        super();
        this.campaigns = []
        this.points = 0;
        this.pointsEl = this.querySelector('.points');
        this.spinnerEl = this.querySelector('.loading-overlay');
        this.pointsPerPurchaseCampaignID = 1321531;
        this.pointsPerPurchaseCampaign = {}
        this.productPrice = this.dataset.productPrice;
        this.pointsPerPound = window.pointsPerProduct;
        this.pointsPerProductFinal = null;
      }
    
      connectedCallback() {

        if(this.pointsPerPound == undefined) {
            document.addEventListener("swell:setup", this.getActiveCampaigns.bind(this))
        } else {
            this.updateDOM();
        }
      }

      getActiveCampaigns() {
        var activeCampaigns = swellAPI.getActiveCampaigns();
        
        activeCampaigns.forEach(campaign => {
            this.campaigns.push(campaign)
        });

        this.pointsPerPurchaseCampaign = this.findPointPerPurchaseCampaign(this.campaigns, this.pointsPerPurchaseCampaignID)

        this.pointsPerPound = this.pointsPerPurchaseCampaign?.rewardPoints;
        if ( !this.pointsPerPound ) return;
        
        this.calculatePoints();

        window.pointsPerProduct = this.pointsPerPound
        
        this.updateDOM()
      }

      findPointPerPurchaseCampaign(array, id) {
        return array.find(obj => obj.id === id);
      }

      calculatePoints() {
        this.pointsPerProductFinal = Math.floor((Math.round(this.productPrice) / 100) * this.pointsPerPound);
      }

      updateDOM() {
        this.calculatePoints();
        this.spinnerEl.remove();
        this.pointsEl.innerText = this.pointsPerProductFinal;
      }

    }
    
    customElements.define('yotpo-points', YotpoProductPoints);
    
}
    